import { PageHeader } from '@/components/PageHeader';
import { StatCard } from '@/components/StatCard';
import { fetchStats } from '@/features/admin/admin-api';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import {
  Activity,
  Building2,
  Database,
  FileSpreadsheet,
  Upload,
  UserCheck,
  Users,
} from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/admin/')({
  component: AdminStatsPage,
});

function AdminStatsPage() {
  const { t } = useTranslation();
  const stats = useQuery({ queryKey: ['admin', 'stats'], queryFn: fetchStats });
  const s = stats.data?.stats;
  const loading = stats.isLoading;

  return (
    <div className="space-y-8">
      <PageHeader
        eyebrow={t('admin.nav.adminPanel', { defaultValue: 'Admin' })}
        title={t('admin.stats.title')}
        description={t('admin.stats.description')}
      />

      <section className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        <StatCard label={t('admin.stats.users')} value={s?.users} icon={Users} loading={loading} />
        <StatCard
          label={t('admin.stats.activeUsers')}
          value={s?.activeUsers}
          icon={UserCheck}
          loading={loading}
        />
        <StatCard
          label={t('admin.stats.orgs')}
          value={s?.orgs}
          icon={Building2}
          loading={loading}
        />
        <StatCard
          label={t('admin.stats.templates')}
          value={s?.templates}
          icon={FileSpreadsheet}
          loading={loading}
        />
        <StatCard
          label={t('admin.stats.datasets')}
          value={s?.datasets}
          icon={Database}
          loading={loading}
        />
        <StatCard
          label={t('admin.stats.exports30d')}
          value={s?.exports30d}
          icon={Upload}
          loading={loading}
          delta={
            <span className="inline-flex items-center gap-1">
              <Activity className="size-3" aria-hidden /> 30d
            </span>
          }
        />
      </section>
    </div>
  );
}
